import { render, staticRenderFns } from "./Modal2.vue?vue&type=template&id=4ef0b330&"
import script from "./Modal2.vue?vue&type=script&lang=js&"
export * from "./Modal2.vue?vue&type=script&lang=js&"
import style0 from "./Modal2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports